module.exports = __webpack_public_path__ + "img/img27.f56620b7.png";